import React from "react";
import Input from "./Input";
import ContactFormatter from "../ContactFormatter/ContactFormatter"


const formatPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, ''); 
};


// const formatPhoneNumber = (value: string) => {
//   const phoneNumber = value.replace(/\D/g, '');

//   if (phoneNumber.length < 4) {
//     return phoneNumber;
//   } else if (phoneNumber.length < 7) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
//   } else {
//     console.log("phone number",phoneNumber)
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
//   }
// };



type ContactInputPropsType = {
  label?: string;
  error?: boolean;
  helperText?: string;
  type?: string;
  onChangeCb?: (e: string) => void;
  disabled?: boolean;
  value?: string;
  name?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  size?: "small" | "medium";
  placeholder?: string;
  style?: Record<string, string>;
  textFieldLabel?: string;
  required?: boolean;
  onBlur?: (e: any) => void;
  isContactNumber?: boolean;
};

const ContactInput = ({
  name,
  type,
  label,
  textFieldLabel,
  value,
  onChangeCb = () => {},
  size,
  error,
  helperText,
  startIcon,
  endIcon,
  style,
  onBlur = (e) => {},
  isContactNumber = false,
}: ContactInputPropsType) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const PhoneNumber = formatPhoneNumber(event.target.value);
    // const formattedPhoneNumber = formatPhoneNumber(strippedPhoneNumber);
        // console.log("formatted number",formattedPhoneNumber)
    onChangeCb(PhoneNumber);
    // event.target.value = formattedPhoneNumber;
  };

  return (
    <Input
      onBlur={onBlur}
      name={name}
      type={type}
      textFieldLabel={textFieldLabel}
      label={label}
      value={value}
      onChangeCb={handleChange}
      size={size}
      error={error}
      helperText={helperText}
      startIcon={startIcon}
      endIcon={endIcon}
      style={style}
      inputComponent={isContactNumber ? ContactFormatter : undefined}
    />
  );
};

export default ContactInput;
